import { Component } from '@angular/core';

@Component({
  selector: 'uni-list-content',
  templateUrl: './uni-list-content.component.html',
  styleUrls: ['./uni-list-content.component.scss'],
})
export class UniListContentComponent {}
